import Marquee from 'jsmarquee';

document.addEventListener("DOMContentLoaded", function(event) {
	if( document.getElementById('announcementBar-marquee') ){
		const m = new Marquee({
			element: '#announcementBar-marquee',
			velocity: 1
		});

		m.run()
	}

});
